module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flows-steps"
  }, [_c('div', {
    staticClass: "steps",
    class: {
      'done': _vm.step >= 1
    }
  }, [_c('span', {
    staticClass: "steps-number"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "steps-title"
  }, [_vm._v("验证身份")])]), _vm._v(" "), _c('div', {
    staticClass: "steps",
    class: {
      'done': _vm.step >= 2
    }
  }, [_c('span', {
    staticClass: "steps-number"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "steps-title"
  }, [_vm._v("修改" + _vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "steps",
    class: {
      'done': _vm.step >= 3
    }
  }, [_c('span', {
    staticClass: "steps-number steps-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "steps-title"
  }, [_vm._v("完成")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-29aa6a8d!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/validation/steps.vue
// module id = Wg47
// module chunks = 15